import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import "./EagleFeedback.css";
import "./KayuhWinnerForm.css";

const KayuhWinnerForm = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        ID: '',
        NameNric: '',
        NRIC: '',
        AccurateInfoAck: false,
        TermsAndCondAck: false,
        DataConsentAck: false,
        AckCutoffDateTime : ''
    });
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [isEligible, setIsEligible] = useState(false);
    const [showIneligiblePopup, setShowIneligiblePopup] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);

    // Calculate deadline date (3 days from now)
    const deadlineDate = new Date();
    deadlineDate.setDate(deadlineDate.getDate() + 3);
    const formattedDeadline = deadlineDate.toLocaleDateString('en-MY', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    });

    useEffect(() => {
        const validateDriverEligibility = async () => {
            try {
                setIsLoading(true);
                const response = await fetch('/form/kayuhWinner', {
                    method: 'GET',
                });

                if (response.ok) {
                    const data = await response.json();
                    setIsEligible(data.eligible);
                    setIsFormSubmitted(data.submitted === '1');
                    setFormData({
                        ID: data.id,
                        NameNric: data.nameNric,
                        NRIC: data.nric,
                        AccurateInfoAck: data.accurateInfoAck,
                        TermsAndCondAck: data.termsAndCondAck,
                        DataConsentAck: data.dataConsentAck,
                        AckCutoffDateTime: data.AckCutoffDateTime
                    })
                   
                    if (data.eligible != '1') {
                        setShowIneligiblePopup(true);
                    }
                } else {
                    setShowIneligiblePopup(true);
                }
            } catch (error) {
                setShowIneligiblePopup(true);
            } finally {
                setIsLoading(false);
            }
        };

        validateDriverEligibility();
    }, []);


    const submitDriverForm = async () => {
        try {
            const response = await fetch('/form/kayuhWinner', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'  // Specify that the content type is JSON
                },
                body: JSON.stringify(
                    {
                        ID :formData.ID,
                        NRIC: formData.NRIC,
                        NameNric: formData.NameNric,
                        AccurateInfoAck: formData.AccurateInfoAck.toString(),
                        TermsAndCondAck:formData.TermsAndCondAck.toString(),
                        DataConsentAck: formData.DataConsentAck.toString()
                    }

                )  // Convert form data to JSON string
            });

            if (response.ok) {
                //const result = await response.json();
                //console.log('Submission successful');
                setIsSubmitted(true);
            } else {
                console.error('Submission failed:', response.statusText);
                alert('Error During Submission')
            }
        }
        catch (error) {
            console.error('An error occurred:', error);
            alert('Error During Submission!')
        }
      
    };

    const handleClosePopup = () => {
        setShowIneligiblePopup(false);
        navigate('/');
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;        
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.NameNric.trim()) {
            newErrors.Name = t('kayuhWinnerForm.errors.NameRequired');
        }

        if (!formData.NRIC.match(/^\d{6}-\d{2}-\d{4}$/)) {
            newErrors.NRIC = t('kayuhWinnerForm.errors.nricFormat');
        }

        if (!formData.AccurateInfoAck || !formData.TermsAndCondAck || !formData.DataConsentAck) {
            newErrors.declarations = t('kayuhWinnerForm.errors.allDeclarationsRequired');
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            console.log('Form submitted:', formData);
            submitDriverForm();
            
        }
    };

    if (isLoading) {
        return (
            <div className="loading-overlay">
                <div className="loading-spinner"></div>
                <p>Loading</p>
            </div>
        );
    }

    if ( showIneligiblePopup) {
        return (
            <div className="ineligible-popup-overlay">
                <div className="ineligible-popup-container">
                    <div className="popup-header">
                        <svg className="popup-icon" viewBox="0 0 24 24">
                            <path fill="currentColor" d="M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12,17c-0.55,0-1-0.45-1-1v-4c0-0.55,0.45-1,1-1s1,0.45,1,1v4C13,16.55,12.55,17,12,17z M13,9h-2V7h2V9z" />
                        </svg>
                        <h2>{t('kayuhWinnerForm.ineligible.title')}</h2>
                    </div>
                    <div className="popup-content">
                        <p>{t('kayuhWinnerForm.ineligible.message')}</p>
                    </div>
                    <div className="popup-footer">
                        <button
                            onClick={handleClosePopup}
                            className="popup-confirm-button"
                        >
                            {t('kayuhWinnerForm.ineligible.okButton')}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    if (isSubmitted) {
        return (
            <div className="submission-success">
                <h1>{t('kayuhWinnerForm.submission.thankYou')}</h1>
                <p>{t('kayuhWinnerForm.submission.received')}</p>
            </div>
        );
    }

    return (
        <form onSubmit={handleSubmit}>
            <div className="form-eagle-feedback">
                <h1>{t('kayuhWinnerForm.title')}</h1>

                <p>{t('kayuhWinnerForm.description.congratulations')}</p>
                <p className="note">
                    <strong>{t('kayuhWinnerForm.description.note')} {t('kayuhWinnerForm.description.deadline', { date: formattedDeadline })} </strong>
                </p>

                {/* Section 1: Reward Details */}
                <div className="form-section">
                    <h2>{t('kayuhWinnerForm.sections.rewards.title')}</h2>

                    <div>
                        <p>{t('kayuhWinnerForm.sections.rewards.description')}:</p>
                        <ul>
                            <li>{t('kayuhWinnerForm.sections.rewards.grandPrize')}</li>
                            <li>RM 10,000</li>
                            <li>RM 5,000</li>
                            <li>RM 500</li>
                            <li>RM 200</li>
                            <li>RM 100</li>
                        </ul>
                        <p>{t('kayuhWinnerForm.sections.rewards.note')}</p>
                    </div>
                </div>

                {/* Section 2: Winner Information */}
                <div className="form-section">
                    <h2>{t('kayuhWinnerForm.sections.winnerInfo.title')}</h2>

                    <div className="form-group">
                        <h3>
                            {t('kayuhWinnerForm.sections.winnerInfo.fullName.label')}
                            <span className="mandatory-message">*</span>
                        </h3>
                        <input
                            type="text"
                            name="NameNric"
                            value={formData.NameNric}
                            onChange={handleChange}
                            placeholder={t('kayuhWinnerForm.sections.winnerInfo.fullName.placeholder')}
                            disabled={isFormSubmitted}
                            style={{ width: '100%' }}
                        />
                        {errors.Name && <span className="error">{errors.Name}</span>}
                        <p className="hint">
                            {t('kayuhWinnerForm.sections.winnerInfo.fullName.hint')}
                        </p>
                    </div>

                    <div className="form-group">
                        <h3>
                            {t('kayuhWinnerForm.sections.winnerInfo.nric.label')}
                            <span className="mandatory-message">*</span>
                        </h3>
                        <input
                            type="text"
                            name="NRIC"
                            value={formData.NRIC}
                            onChange={handleChange}
                            placeholder={t('kayuhWinnerForm.sections.winnerInfo.nric.placeholder')}
                            style={{ width: '100%' }}
                            disabled={isFormSubmitted}
                        />
                        {errors.NRIC && <span className="error">{errors.NRIC}</span>}
                        <p className="hint">
                            {t('kayuhWinnerForm.sections.winnerInfo.nric.hint')}
                        </p>
                    </div>
                </div>

                {/* Section 3: Agreement & Declaration */}
                <div className="form-section">
                    <h2>{t('kayuhWinnerForm.sections.declaration.title')}</h2>

                    <div className={`checkbox-group ${errors.declarations ? 'error' : ''}`}>
                        <label>
                            <input
                                type="checkbox"
                                name="AccurateInfoAck"
                                checked={formData.AccurateInfoAck}
                                onChange={handleChange}
                                disabled={isFormSubmitted}
                            />
                            <div>
                                {t('kayuhWinnerForm.sections.declaration.AccurateInfoAck')}
                                <a target="_blank" href="https://www.grab.com/my/kayuhdanmenang/">{t('kayuhWinnerForm.clickHere')}</a>
                            </div>
                        </label>

                        <label>
                            <input
                                type="checkbox"
                                name="TermsAndCondAck"
                                checked={formData.TermsAndCondAck}
                                onChange={handleChange}
                                disabled={isFormSubmitted}
                            />
                            <div>
                                {t('kayuhWinnerForm.sections.declaration.TermsAndCondAck')}
                                <a target="_blank" href="https://assets.grab.com/wp-content/uploads/sites/8/2025/01/10141546/EN-Kayuh-Menang_TC.pdf">{t('kayuhWinnerForm.clickHere')}</a>
                            </div>
                        </label>

                        <label>
                            <input
                                type="checkbox"
                                name="DataConsentAck"
                                checked={formData.DataConsentAck}
                                onChange={handleChange}
                                disabled={isFormSubmitted}
                            />
                            <div>
                                {t('kayuhWinnerForm.sections.declaration.DataConsentAck')} <a target="_blank" href="https://www.grab.com/my/terms-policies/privacy-notice/">https://www.grab.com/my/terms-policies/privacy-notice/</a>
                            </div>
                        </label>

                        {errors.declarations && <span className="error">{errors.declarations}</span>}
                    </div>
                </div>

                {/* Section 4: Submission Confirmation */}
                <div className="form-section">
                    <h2>{t('kayuhWinnerForm.sections.notes.title')}</h2>

                    <div>
                        <p>
                            1. {t('kayuhWinnerForm.sections.notes.deadlineWarning', { date: formattedDeadline })}
                        </p>

                        <p>
                            2. {t('kayuhWinnerForm.sections.notes.eligibility')}
                        </p>
                    </div>
                </div>

                <p className="form-footer">
                    {t('kayuhWinnerForm.footer.thankYou')}
                </p>
            </div>
            <button type="submit" disabled={isFormSubmitted} className="submit-button">{t('kayuhWinnerForm.footer.submitButton')}</button>
        </form>
    );
};

export default KayuhWinnerForm;